import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-phone',
    templateUrl: './phone.component.html',
    styleUrls: ['./phone.component.scss'],
    standalone: false
})
export class PhoneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
